"use client";

import { UseFormReturn } from "react-hook-form";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { AuthCard } from "@/components/(auth)/auth-card";
import { TermsFooter } from "@/components/(auth)/login/terms-footer";
import { KeyRound } from "lucide-react";
import { AUTH_ROUTES } from "@/constants/routes";
import type { EmailFormData } from "./login-form.types";

interface EmailStepProps {
  form: UseFormReturn<EmailFormData>;
  isLoading: boolean;
  error: string;
  onPasswordClick: () => void;
}

export function EmailStep({
  form,
  isLoading,
  error,
  onPasswordClick,
}: EmailStepProps) {
  return (
    <>
      <AuthCard title="Welcome" subtitle="Login to your account">
        <Form {...form}>
          <form
            className="space-y-6"
            onSubmit={form.handleSubmit(() => onPasswordClick())}
          >
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Email</FormLabel>
                  <FormControl>
                    <Input
                      type="email"
                      placeholder="me@example.com"
                      autoComplete="username"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <Button
              type="submit"
              className="h-12 w-full justify-center gap-3"
              disabled={isLoading}
            >
              <KeyRound className="h-5 w-5" />
              Continue with password
            </Button>
          </form>
        </Form>

        <div className="space-y-6">
          {error && (
            <div className="text-center text-sm text-red-500">{error}</div>
          )}

          <div className="text-center">
            <Link
              href={AUTH_ROUTES.FORGOT_PASSWORD}
              className="text-sm underline underline-offset-4 hover:text-primary"
            >
              Forgot your password?
            </Link>
          </div>
        </div>
      </AuthCard>
      <TermsFooter />
    </>
  );
}
